import React from "react";
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Input,
  InputAdornment,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import ValueBookiesFilter from "./ValueBookiesFilter";
import { getSportsIcon, sportsIcons } from "../../constants";

const ValuePageFilters = ({
  extraFilters,
  bookmakers,
  onExtraFiltersChange,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const containerStyles = {
    display: "flex",
    gap: "16px",
    marginBottom: "16px",
    justifyContent: "center",
    width: "100%",
    alignItems: "center",
    flexDirection: isMobile ? "column" : "row",
  };

  const itemStyles = {
    width: isMobile ? "100%" : undefined,
  };

  // Helper function to ensure sport value is always an array
  const ensureArray = (value) => {
    if (!value) return [];
    return Array.isArray(value) ? value : [value];
  };

  return (
    <Box sx={containerStyles}>
      <Box sx={{ ...itemStyles, width: isMobile ? "100%" : "350px" }}>
        <ValueBookiesFilter
          bookmakers={bookmakers}
          selectedBookmakers={extraFilters.selectedBookmakers}
          onBookmakersChange={(newBookmakers) =>
            onExtraFiltersChange({ selectedBookmakers: newBookmakers })
          }
        />
      </Box>

      <FormControl sx={{ ...itemStyles, width: isMobile ? "100%" : "200px" }}>
        <InputLabel id="sport-select-label">Sports</InputLabel>
        <Select
          labelId="sport-select-label"
          id="sport-select"
          multiple
          value={ensureArray(extraFilters.selectedSport)}
          onChange={(e) =>
            onExtraFiltersChange({ selectedSport: e.target.value })
          }
          startAdornment={
            extraFilters.selectedSport?.length > 0 && (
              <InputAdornment position="start">
                {getSportsIcon(extraFilters.selectedSport[0])}
              </InputAdornment>
            )
          }
          endAdornment={
            extraFilters.selectedSport?.length > 0 && (
              <InputAdornment position="end">
                <IconButton
                  aria-label="clear sports"
                  onClick={() => onExtraFiltersChange({ selectedSport: [] })}
                  edge="end"
                  size="small"
                  sx={{ marginRight: "8px" }}
                >
                  <ClearIcon />
                </IconButton>
              </InputAdornment>
            )
          }
          label="Sports"
        >
          {Object.keys(sportsIcons).map((sport) => (
            <MenuItem key={sport} value={sport}>
              {sport}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl sx={{ ...itemStyles, width: isMobile ? "90%" : "150px" }}>
        <InputLabel htmlFor="max-odds">Max Odds</InputLabel>
        <Input
          id="max-odds"
          type="number"
          value={extraFilters.maxOdds}
          onChange={(e) => onExtraFiltersChange({ maxOdds: e.target.value })}
        />
      </FormControl>

      <FormControl sx={{ ...itemStyles, width: isMobile ? "90%" : "150px" }}>
        <InputLabel htmlFor="bookie-count">Min Bookie Count</InputLabel>
        <Input
          id="bookie-count"
          type="number"
          value={extraFilters.bookieCount}
          onChange={(e) =>
            onExtraFiltersChange({ bookieCount: e.target.value })
          }
        />
      </FormControl>

      <FormControl sx={{ ...itemStyles, width: isMobile ? "90%" : "150px" }}>
        <InputLabel htmlFor="hours-to-event">Hours To Event</InputLabel>
        <Input
          id="hours-to-event"
          type="number"
          value={extraFilters.hoursToEvent}
          onChange={(e) =>
            onExtraFiltersChange({ hoursToEvent: e.target.value })
          }
        />
      </FormControl>
    </Box>
  );
};

export default ValuePageFilters;
